export const enum EventNames {
  RecommendationsError = "recommendations-error:v1",
  ContinueButtonClicked = "continue-button-cliked:v1",
  // Event sent by recommendations stack when a product is added to the cart
  ProductAddedToCart = "productAddedToCart",
}

export type RecommendationsErrorDetail = {
  error: Error | string;
};

export type ContinueButtonClickedDetail = {
  nextUrl: string;
};
